import * as React from "react";
import { createSvgIcon } from "@material-ui/core/utils";
export var iconPath = (React.createElement("path", { d: "M3 12a2 2 0 114 0 2 2 0 01-4 0zm7 0a2 2 0 114 0 2 2 0 01-4 0zm9-2a2 2 0 100 4 2 2 0 000-4z" }));
export default createSvgIcon(iconPath, "More");
//# sourceMappingURL=MoreIcon.js.map